import { components } from '@kurtosys/ksys-app-components';

import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.jsx';

const Dropdown = components.base.Dropdown.Dropdown;

export default InjectedStyledComponent(Dropdown, 'dropdown', ['dropdownComponent']);
